import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthenticationService, AuthService } from '../_services';

@Component({ templateUrl: 'newlogin.component.html' })
export class NewAuthLoginComponent implements OnInit {
    loginForm: FormGroup;
    loading = false;
    submitted = false;
    returnUrl: string;
    error = '';

    constructor(
        private formBuilder: FormBuilder,
        private route: ActivatedRoute,
        private router: Router,
        private authenticationService: AuthService
    ) { 
        // redirect to home if already logged in
        if (this.authenticationService.currentUserValue) { 
            this.router.navigate(['/']);
        }
    }

    ngOnInit() {
        this.loginForm = this.formBuilder.group({
            username: ['', Validators.required],
            password: ['', Validators.required]
        });
        // this.loginForm = this.formBuilder.group({
        //     username: ['admin', Validators.required],
        //     password: ['Fkt@85505', Validators.required],
        //     customer: ['101', Validators.required]
        // });

        // get return url from route parameters or default to '/'
        this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
    }

    // convenience getter for easy access to form fields
    get f() { return this.loginForm.controls; }

    onSubmit() {
        this.submitted = true;
        if (this.loginForm.invalid) return;

        this.loading = true;
        this.authenticationService.login(this.f.username.value, this.f.password.value).subscribe(
            user => {
                if (user && user.isSuccess()) this.router.navigate([this.returnUrl]);
                else {
                    this.error = 'خطا';
                    this.loading = false;
                }
            },
            error => {
                this.error = error;
                this.loading = false;
            }
        )
            // .pipe(first())
            // .subscribe(
            //     user => {
            //         if (user && user.issuccess) this.router.navigate([this.returnUrl]);
            //         else {
            //             this.error = 'خطا';
            //             this.loading = false;
            //         }
            //     },
            //     error => {
            //         this.error = error;
            //         this.loading = false;
            //     });
    }
}